import { IS_SIDEKICK_APP } from '../constants/projects';

export const Categories = {
    u5h5ctdh84: {
        label: 'Personal projects',
        color: '#3AD3EF',
        uid: 'u5h5ctdh84',
        subCategories: [
            {
                label: 'Strategy',
                uid: '9m5twx0i4s',
            },
            {
                label: 'Design/Branding',
                uid: 'n10slnw5c9',
            },
            {
                label: 'Copy/PR',
                uid: '9tg9rjl633',
            },
            {
                label: 'Film/Production',
                uid: 'f8rn6bhziu',
            },
            {
                label: 'Data/Metrics analysis',
                uid: 'iq9yy7dgpt',
            },
            {
                label: 'Ad Channels',
                uid: 'qlb8UdG8cQ',
            },
            {
                label: 'Performance Marketing',
                uid: 'bQlNwyws36',
            },
            {
                label: 'Other',
                uid: 'qJFeXec5aE',
            },
        ],
    },
    gaxwv5y6g9: {
        label: 'General questions',
        color: '#41E6D3',
        uid: 'gaxwv5y6g9',
        subCategories: [
            {
                label: 'Design/UX/UI',
                uid: 'hm2t3z3fpt',
            },
            {
                label: 'Features',
                uid: '5oxhu14i5z',
            },
            {
                label: 'Front End',
                uid: '9zw4qqc2hz',
            },
            {
                label: 'Back End',
                uid: '2WgHATyX35',
            },
            {
                label: 'Tools',
                uid: 'miGElbL7kT',
            },
            {
                label: 'Other',
                uid: 'g6BDlETgGK',
            },
        ],
    },
    r1cq9ri9p9: {
        label: 'Work team',
        color: '#EFD028',
        uid: 'r1cq9ri9p9',
        subCategories: [
            {
                label: 'Raising Funds',
                uid: '6j8bc6c0co',
            },
            {
                label: 'Growth',
                uid: 'p0w9rgzeyi',
            },
            {
                label: 'Markets',
                uid: '1MImMRdtP3',
            },
            {
                label: 'Legal',
                uid: 'Au646bYYWq',
            },
            {
                label: 'Recruitment',
                uid: 'ADzWDxThws',
            },
            {
                label: 'Other',
                uid: 'FBgiQs9E6c',
            },
        ],
    },
};

export const SidekickCategories = {
    design: {
        label: 'Design',
        color: '#29CEFF',
        uid: 'design',
        subCategories: [],
    },
    film: {
        label: 'Film',
        color: '#41E6D3',
        uid: 'film',
        subCategories: [],
    },
    animation: {
        label: 'Animation',
        color: '#EDCB0F',
        uid: 'animation',
        subCategories: [],
    },
    web: {
        label: 'Web',
        color: '#ED870F',
        uid: 'web',
        subCategories: [],
    },
    strategy: {
        label: 'Strategy',
        color: '#ED0F42',
        uid: 'strategy',
        subCategories: [],
    },
};

export const DefaultCategory = IS_SIDEKICK_APP
    ? {
          label: 'design',
          color: '#29CEFF',
      }
    : {
          label: '',
          color: '#6DC9FA',
      };
